import axios from 'axios';
import { getToken, endSession, isSessionEnding } from './auth';

// Endpoints used before the user has a token
const PUBLIC_PATHS = [
  'user/authenticate_user',
  'user/verify_otp',
  'user/resend_otp',
  'user/forgot_password',
];
const isPublic = (url = '') => PUBLIC_PATHS.some((p) => url.startsWith(p));


//axios.defaults.baseURL = '/api/v1/';

// const baseURL = 'http://172.27.21.24:8282/api/v1/';
// const baseURL = 'http://172.27.8.43/api/v1/';
//const baseURL = window.location.origin + '/api/v1/';
const baseURL = '/api/v1/';

// Production logs in with a cookie instead of a token (see auth.js).
// Set to true when the API is on a different domain or port than the app,
// so the browser stores and sends that cookie. The API must then allow
// credentials in its CORS settings. Not needed when the API is same-origin
// (e.g. baseURL '/api/v1/').
const sendCookies = false;

//console.log(baseURL);
const api = axios.create({
  baseURL: baseURL,
  allowAbsoluteUrls: false,
  withCredentials: sendCookies,
});

api.interceptors.request.use((config) => {
  const url = config.url || '';
  if (/^https?:\/\//i.test(url) || url.startsWith('//')) {
    return Promise.reject(new Error('Absolute URLs are not allowed'));
  }

  // Already logging out: don't send more calls that need a session
  if (isSessionEnding() && !isPublic(url)) {
    return Promise.reject(new Error('Session expired'));
  }

  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else if (!isPublic(url) && localStorage.getItem('token')) {
    // The token has expired: don't send a request we know will be rejected
    endSession();
    return Promise.reject(new Error('Session expired'));
  }
  return config;
});

// The backend rejected the token (expired, revoked or invalid)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = (error.config && error.config.url) || '';
    if (error.response && error.response.status === 401 && !isPublic(url)) {
      endSession();
    }
    return Promise.reject(error);
  },
);

export default api;